import { Component, signal, computed } from "@angular/core";
import { SuggestionOption } from "../../models";
import { IaAvatarComponent } from "../../../ia-avatar/ia-avatar.component";

@Component({
  selector: "app-mentions-popover",
  imports: [IaAvatarComponent],
  templateUrl: "./mentions-popover.component.html",
  styleUrl: "./mentions-popover.component.scss",
})
export class MentionsPopoverComponent {
  #maxPopoverWidth = 290;
  /** mentionables */
  suggestions = signal<SuggestionOption[]>([]);
  /** Vertical distance from screen top of the target element */
  top = signal<number>(0);
  /** Left position of the target element */
  left = signal<number>(0);

  /** Top position of the popover */
  topPx = computed<string>(() => {
    let top = this.top();
    if (top < 0) top = 0;
    return `${this.top() - 10}px`;
  });
  /** Left position of the popover - adjusted to is doesn't go off screen */
  leftPx = computed<string>(() => {
    let adjustedLeft = this.left();
    const viewportWidth = window.innerWidth;
    // Prevent popover from going off the right side
    if (adjustedLeft + this.#maxPopoverWidth > viewportWidth) {
      adjustedLeft = viewportWidth - this.#maxPopoverWidth;
    }
    return `${adjustedLeft}px`;
  });

}
